import http from '@root/utils/axios/admin';

let state = {
    AccountanciesList: [],
}

let actions = {

    fetchAccountanciesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/accountancies', { params: filter }).then((response) => {
                commit('setAccountancies', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    rechargeCardCenterSettlement({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/recharge-card-center-settlement', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {}
                reject(error.response);
            })
        });

    },


}


let mutations = {
    setAccountancies(state, data) {
        state.AccountanciesList = data;
    },


}

export default {
    state,
    actions,
    mutations
}